import store from '../../stores/redux';
import UserStore from '../../stores/UserStore';
import { initialState } from '../../reducer/serverStorage';
import typeOf from '../../helpers/typeOf';
import config from './config';

const version = initialState.store.dataTable.version;

const helper = {
    toTimestamp(strDate){
        var datum = Date.parse(strDate);
        return datum/1000;
    },

    getDate(key) {
        const storeVersion = store.getState().serverStorage.store.dataTable.version;
        const storeData = store.getState().serverStorage.store.dataTable[key] || [];
        const staticNames = UserStore.getTranslation().dataTable.headers;
        let list = [];

        if (!config.headers || !config.headers[key] || !Array.isArray(config.headers[key])) {
            return list;
        }

        config.headers[key].map((item, i) => {
            let storeItem = storeData[i] || {};
            let newItem = {
                ...item,
                ...storeItem
            };

            item.keyHint && (newItem.hint = helper.getHint(item.keyHint));

            if (
                version !== storeVersion ||
                item.keyTitle !== storeItem.keyTitle // fix different in storage and local configs
            ) {
                newItem = {...item};
            }

            list.push({
                title: staticNames[item.keyTitle] || item.keyTitle,
                ...newItem
            });
        });

        return list;
    },

    getHint(key) {
        const staticNames = UserStore.getTranslation().dataTable.hints;
        return staticNames[key] || '';
    },

    dateDelete(data) {
        if (!typeOf.isArray(data)) {
            return data;
        }

        return data.map(item => {
            delete item.hint;
            delete item.title;
            return item;
        });
    }
};

export default helper;
